<template>
  <div class="content_box">
    <div id="menuManage">
      <div class="leftTree">
        <el-tree
          node-key="id"
          ref="tree"
          :data="menuTree"
          :props="defaultProps"
          @node-click="handleNodeClick"
          v-loading="menuTreeLoading"
        ></el-tree>
      </div>
      <div class="rightCon contentPadding42" id="ManageTable">
        <div class="headTitle">
          <img src="@/assets/imgs/icon/icon_headIcon.png" alt />
          地区代码
        </div>
        <!-- <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="地区代码" style="margin-right: 30px">
          <el-input
            v-model="searchObj.code"
            placeholder="请输入代码"
          ></el-input>
        </el-form-item>
        <el-form-item label="地区名称" style="margin-right: 30px">
          <el-input
            v-model="searchObj.name"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSearch"
            class="bg5584FF formBotton"
            style="margin-left: 40px"
            >查询</el-button
          >
          <el-button type="info" @click="onReset" class="formBotton"
            >重置</el-button
          >
        </el-form-item>
      </el-form> -->
        <hr />
        <el-button type="primary" size="small" class="bg5584FF" @click="addNew">
          <i class="el-icon-plus"></i> 新增地区
        </el-button>
        <div style="height: 20px"></div>
        <el-table
          border
          v-loading="loading"
          :data="menuList.children"
          style="width: 100%"
          stripe
          :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
        >
          <el-table-column
            align="center"
            prop="value"
            label="地区代码"
          ></el-table-column>
          <el-table-column align="center" prop="label" label="地区名称">
            <!-- <template slot-scope="scope">
            <a
              style="color: #5582f7; cursor: pointer"
              @click="toShow(scope.row)"
              >{{ scope.row.label }}</a
            >
          </template> -->
          </el-table-column>
          <el-table-column
            align="center"
            v-model="menuList.label"
            label="上级地区"
          >
            <span>{{ menuList.label }}</span>
          </el-table-column>

          <el-table-column align="center" label="操作" width="300">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="MR18 bg5584FF"
                type="primary"
                @click="editMenu(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                class="MR18 bg5584FF"
                type="primary"
                @click="deleteMenu(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="pageBox">
        <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="10"
            layout="total,  prev, pager, next"
            :total="totalNum"
          >
          </el-pagination>
      </div> -->
      </div>
      <!-- 删除弹框 -->
      <el-dialog title="删除" :visible.sync="showDeleteWindow" class="delete">
        <p>确认要删除地区"{{ deleteName }}"？</p>
        <div class="btnBox MT40">
          <el-button
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="sureDelete"
            >确定</el-button
          >
          <el-button type="normal" size="mini" @click="showDeleteWindow = false"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <!-- 查看弹框 -->
      <el-dialog
        title="查看地区"
        :visible.sync="showWindow"
        class="dialog770 titleChange"
        width="470px"
      >
        <el-form
          ref="editForm"
          :model="showObj"
          label-width="130px"
          size="small"
        >
          <el-form-item label="地区代码：">
            <el-input disabled v-model="showObj.value"></el-input>
          </el-form-item>
          <el-form-item label="地区名称：">
            <el-input disabled v-model="showObj.label"></el-input>
          </el-form-item>
          <el-form-item
            label="上级地区："
            v-if="showObj.parent_code !== '000000'"
          >
            <el-input disabled v-model="showObj.parentId"></el-input>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 编辑弹框 -->
      <el-dialog
        title="编辑地区"
        :visible.sync="showEditWindow"
        class="dialog770 titleChange"
        width="470px"
      >
        <el-form
          ref="editForm"
          :model="editObj"
          label-width="130px"
          size="small"
          v-loading="editLoading"
        >
          <el-form-item label="地区代码：" prop="id">
            <el-input disabled v-model="editObj.value"></el-input>
          </el-form-item>
          <el-form-item label="地区名称：" prop="name">
            <el-input v-model="editObj.label"></el-input>
          </el-form-item>

          <el-form-item
            label="上级地区："
            prop="parentName"
            v-if="editObj.parentId !== '000000'"
          >
            <el-input disabled v-model="editObj.parentId"></el-input>
          </el-form-item>
        </el-form>
        <div class="btnBox">
          <el-button
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="sureEdit"
            >提交</el-button
          >
          <el-button type="normal" size="mini" @click="showEditWindow = false"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <!-- 新增提升 -->
      <el-dialog title="提示" :visible.sync="showAddFalse" class="delete">
        <p>请选中左侧地区名称后点击</p>
        <div class="btnBox MT40">
          <el-button type="normal" size="mini" @click="showAddFalse = false"
            >确定</el-button
          >
        </div>
      </el-dialog>
      <!-- 新增弹框 -->
      <el-dialog
        title="新增地区"
        :visible.sync="showAddWindow"
        class="dialog770 titleChange"
        width="470px"
      >
        <el-form
          ref="addForm"
          :model="addObj"
          label-width="130px"
          size="small"
          v-loading="addLoading"
          :rules="rules"
        >
          <el-form-item label="地区代码：" prop="id">
            <el-input v-model="addObj.id"></el-input>
          </el-form-item>
          <el-form-item label="地区名称：" prop="name">
            <el-input v-model="addObj.name"></el-input>
          </el-form-item>

          <el-form-item
            label="上级地区："
            prop="parentName"
            v-if="addObj.parentId !== '000000'"
          >
            <el-input disabled v-model="addObj.parentName"></el-input>
          </el-form-item>

          <el-form-item>
            <div class="btnBox">
              <el-button
                type="primary"
                size="mini"
                class="bg5584FF"
                @click="sureAdd"
                >新增</el-button
              >
              <el-button
                type="normal"
                size="mini"
                @click="showAddWindow = false"
                >取消</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
export default {
  data() {
    return {
      menuTree: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      searchObj: {
        name: "",
        code: "",
      },
      menuList: [],
      treeData: [],
      editObj: {},
      addObj: {},
      showObj: {},
      deleteId: "",
      currentPage: 1,
      showDeleteWindow: false,
      showWindow: false,
      showEditWindow: false,
      showAddWindow: false,
      showAddFalse: false,
      loading: false,
      addLoading: false,
      menuTreeLoading: false,
      editLoading: false,
      totalNum: 0,
      pageSize: 20,
      pageObj: {},
      deleteName: "",
      rules: {
        name: [
          { required: true, message: "请填写地区名称", trigger: "change" },
        ],
        id: [{ required: true, message: "请填写地区代码", trigger: "change" }],
        parentName: [
          { required: true, message: "请选择上级地区", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    onSearch() {
      this.getMenuList(1);
    },
    onReset() {
      this.searchObj.name = "";
      this.searchObj.code = "";
      this.searchObj.parent_code = null;
      this.getMenuList(1);
    },
    addNew() {
      console.log(this.addObj);
      if (this.addObj.parent_code) {
        this.addObj = {
          id: "",
          name: "",
          parentId: this.addObj.parent_code,
          parentName: this.addObj.parent_name,
        };
        this.showAddWindow = true;
      } else {
        this.showAddFalse = true;
      }
    },
    sureAdd() {
      console.log(this.addObj);
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$axios
            .post("/business/mapSite/addAreaInfo", this.addObj)
            .then((res) => {
              Message.success("新增成功");
              this.addLoading = false;
              this.showAddWindow = false;
              this.getMenuList();
              this.getMenuTree();
            })
            .catch((res) => {
              this.addLoading = false;
              console.log("新增失败", res);
            });
        } else {
          Message.error("请完善表单信息");
          return false;
        }
      });
    },
    editMenu(row) {
      this.editObj = JSON.parse(JSON.stringify(row));
      console.log(this.editObj);

      this.showEditWindow = true;
    },
    toShow(row) {
      this.showObj = JSON.parse(JSON.stringify(row));
      console.log(this.showObj);
      this.showWindow = true;
    },
    sureEdit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          console.log("编辑对象", this.editObj);
          this.$axios
            .put("/business/mapSite/updateAreaInfo", {
              id: this.editObj.value,
              name: this.editObj.label,
              parentId: this.editObj.parentId,
            })
            .then((res) => {
              Message.success("修改成功");
              this.editLoading = false;
              this.showEditWindow = false;
              this.getMenuList();
              this.getMenuTree();
              console.log("编辑成功", res);
            })
            .catch((res) => {
              this.editLoading = false;
              console.log("编辑错误", res);
            });
        } else {
          Message.error("请完善表单信息");
        }
      });
    },
    deleteMenu(row) {
      this.deleteId = row.value;
      console.log(row);
      this.deleteName = row.name;
      this.showDeleteWindow = true;
    },
    sureDelete() {
      this.$axios
        .post("/business/mapSite/deleteAreaInfo", [this.deleteId])
        .then(() => {
          Message.success("删除成功");
          this.showDeleteWindow = false;
          this.getMenuList();
          this.getMenuTree();
        })
        .catch((res) => {
          console.log("删除失败", res);
          this.showDeleteWindow = false;
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getMenuList(1);
    },
    handleCurrentChange(current) {
      this.getMenuList(current);
    },
    handleNodeClick(obj, node) {
      if (obj.value !== "000000") {
        this.searchObj["parent_code"] = obj.value;
      } else {
        this.searchObj["parent_code"] = null;
      }

      console.log(obj);
      this.addObj.parent_code = obj.value;
      this.addObj.parent_name = obj.label;
      this.getMenuList();
    },
    getNoteData(node, data) {
      data.unshift(node.data.value);
      if (node.parent !== null) {
        this.getNoteData(node.parent, data);
      }
    },
    //获取地区树
    getMenuTree() {
      this.menuTreeLoading = true;
      this.$axios
        // .get("/business/dm/dq/tree")
        .get("/business/mapSite/getTree")
        .then((res) => {
          this.menuTree = [
            {
              label: "地区",
              code: "000000",
              value: "000000",
              children: [],
            },
          ];
          console.log("地区树结果", res.data.data.children);
          if (res.data.data.children.length) {
            this.treeData = [...res.data.data.children];

            this.menuTree[0]["children"] = res.data.data.children;
          }
          // console.log("地区树结果", res.data);
          // if (res.data.length) {
          //   this.treeData = [...res.data];

          //   this.menuTree[0]["children"] = this.toTree(res.data, "000000");
          // }
          this.menuTreeLoading = false;
        })
        .catch((res) => {
          console.log("地区树获取失败", res);
          this.menuTreeLoading = false;
        });
    },
    toTree(treeData, parentId) {
      const treeArr = [];
      console.log(treeData);
      for (let i = 0; i < treeData.length; i++) {
        const node = treeData[i];

        if (node.parent_code === parentId) {
          const newNode = {
            code: node.code,
            value: node.code,
            name: node.name,
            label: node.code + node.name,
            children: this.toTree(treeData, node.code),
          };
          treeArr.push(newNode);
        }
      }
      console.log(treeArr);
      return treeArr;
    },
    //获取表格信息
    getMenuList(page) {
      this.loading = true;
      const param = Object.assign(
        {
          page: page ? page : 1,
          size: this.pageSize,
        },
        this.searchObj
      );
      console.log(this.searchObj);
      if (this.searchObj.parent_code) {
        this.$axios
          // .post("/business/dm/dq/page", param)
          .get(`/business/mapSite/getTree?code=${this.searchObj.parent_code}`)
          .then((res) => {
            this.loading = false;
            this.menuList = res.data.data;
            this.totalNum = res.total;
            console.log("地区列表结果", res);
          })
          .catch((res) => {
            this.loading = false;
            console.log("地区列表错误信息", res);
          });
      } else {
        this.searchObj.parent_code = "000000";
      }
    },
    getParentName(code, row) {
      if (code === "000000") {
        return "";
      } else {
        for (let i = 0; i < this.treeData.length; i++) {
          if (this.treeData[i].code === code) {
            row["parent_name"] = this.treeData[i].name;
            return this.treeData[i].name;
          }
        }
      }
    },
  },
  created() {
    this.getMenuTree();
    // this.getMenuList();
  },
};
</script>

<style lang="less" scoped>
.content_box {
  padding: 20px 30px 30px;
}
@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
}
#menuManage {
  box-shadow: 0px 0px 50px #ccc;
  height: calc(90vh - 76px);
  display: flex;
  .leftTree {
    width: 260px;
    background-color: rgba(247, 248, 250, 1);
    box-sizing: border-box;
    padding: 20px 0px;
    height: 100%;
    overflow-y: auto;
  }
  .rightCon {
    width: calc(100% - 260px);
    height: 100%;
    overflow-y: auto;
    border-left: 1px solid rgb(220, 223, 230);
  }
  .el-cascader {
    width: 100%;
  }
}
#menuManage /deep/ .el-tree-node__children {
  .el-tree-node__label {
    padding: 2px 4px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  }

  .el-tree-node.is-current {
    background: rgba(247, 248, 250, 1);
    & > div:first-child .el-tree-node__label {
      background-color: #5584ff;
      color: #fff;
      box-shadow: 0px 2px 4px 0px #5584ff;
    }
  }
}
#menuManage .el-tree {
  background: rgba(247, 248, 250, 1);
}
.headTitle {
  font-size: 24px;
  font-weight: bold;
  color: rgba(68, 68, 68, 1);
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  img {
    margin-right: 24px;
    padding-left: 2px;
  }
}
hr {
  border-color: rgba(155, 155, 155, 0.2);
  margin: 10px 0 20px;
}
</style>